/**
 * The proposal schema has one `opportunity_cost` column; the form stores the
 * "constraints" answer inside it after a fixed separator. Splitting on load
 * and re-joining on submit keeps an edit idempotent — before this, reloading
 * an existing proposal copied the whole column into both fields and every
 * resubmit nested another "Constraints:" block inside it.
 */
const CONSTRAINTS_SEPARATOR = '\n\nConstraints: ';

export function splitOpportunityCost(stored: string | null | undefined): { opportunity: string; constraints: string } {
  const text = stored ?? '';
  const idx = text.indexOf(CONSTRAINTS_SEPARATOR);
  if (idx === -1) {
    // A column that is *only* a constraints block (no opportunity text before it).
    if (text.startsWith('Constraints: ')) return { opportunity: '', constraints: text.slice('Constraints: '.length) };
    return { opportunity: text, constraints: '' };
  }
  return {
    opportunity: text.slice(0, idx),
    constraints: text.slice(idx + CONSTRAINTS_SEPARATOR.length),
  };
}

export function joinOpportunityCost(opportunity: string, constraints: string): string {
  const o = opportunity.trim();
  const c = constraints.trim();
  if (!c) return o;
  if (!o) return `Constraints: ${c}`;
  return `${o}${CONSTRAINTS_SEPARATOR}${c}`;
}
